import { styled } from "@mui/material";
import { types } from "api";
import { InfoSnackBar } from "components/InfoSnackBar";
import { DELETE_FAIL } from "messages";
import { useState } from "react";
import { StudentGroupListItem } from "./StudentGroupListItem";

const PREFIX = "GroupList";

const classes = {
	root: `${PREFIX}-root`,
};

const Root = styled("div")(() => ({
	[`&.${classes.root}`]: {
		width: "100%",
	},
}));

export interface GroupListProps {
	groups: types.Group[];
	handleClick: (groupId: string) => void;
}

export const StudentGroupList = ({
	groups,
	handleClick,
}: GroupListProps): JSX.Element => {
	const [err, setErr] = useState<boolean>(false);

	return (
		<Root className={classes.root}>
			{groups.map((row, index) => {
				const labelId = `assignment-${index}`;

				return (
					<StudentGroupListItem
						group={row}
						handleClick={handleClick}
						labelId={labelId}
						key={row.name}
					/>
				);
			})}
			<InfoSnackBar
				isOpen={err}
				onClose={() => setErr(false)}
				message={DELETE_FAIL}
				severity="error"
			/>
		</Root>
	);
};
